import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from '../utilities/services/http.service';
import { TranslateService } from '@ngx-translate/core';
import { AgencyRoleType } from '../utilities/enums/agencyrole.enum';
import { LocalStorageService } from '../utilities/services/local-storage.service';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  selectedAgencyCode: any = "";
  agencyCodeList: any = [];
  isShowAgency: boolean = false;
  showLoader: boolean = false;
  showUserGuide: boolean = false;
  isLoggedIn: boolean = false;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private localStorageService: LocalStorageService
  ) {
   }

  ngOnInit(): void {
    this.initializeAgencyCode();
    this.isShowAgency = this.router.url !== '/login';

    let x = AppComponent.getAllInstances()[0];
    this.isLoggedIn = x ? x.isLoggedIn : false;

  }

  private initializeAgencyCode(): void {
    const storedString = localStorage.getItem('allAgencyCode');
    if (storedString) {
      this.agencyCodeList = storedString.split(';');
    }
    const savedCode = localStorage.getItem('agencycode');
    if (savedCode) {
      this.selectedAgencyCode = savedCode;
    } else if (this.agencyCodeList.length > 0) {
      this.selectedAgencyCode = this.agencyCodeList[0];
      localStorage.setItem('agencycode', this.selectedAgencyCode);
    }
    // console.log(this.agencyCodeList)
  }

  onAgencyCodeChange(selectedCode: string): void {
    this.localStorageService.setItem('agencycode', selectedCode);
    this.router.navigateByUrl(this.router.url).then(() => {
    });
  }

  logOut() {
    let x = AppComponent.getAllInstances()[0]
    x.logout()
    // let currentUrl = this.router.url;
    // if(currentUrl.indexOf('/threads/') > -1)
    //   currentUrl = '/threads';

    // this.httpService.removePushToken({
    //   email: localStorage.getItem('userEmail'),
    //   pushToken: localStorage.getItem('pushToken'),
    // }).subscribe();

    // localStorage.clear();
    // localStorage.setItem('redirectUrl', currentUrl);
    // this.router.navigate(['/login']);
  }

  addNotificationComponent() {
    let x = AppComponent.getAllInstances()[0];
    x.ShowNotificationComponent(true);
  }

  isUserAuthenticated() {
    const token = localStorage.getItem('userAccessToken');
    if (token) {
      return true;
    }
    return false;
  }

  hasUnreadNotification() {
    return AppComponent.getAllInstances()[0].notificationComponent?.instance.hasUnread;
  }

  ShowMenuCards() {
    const loginUserRealmRole = localStorage.getItem('Role');
    const loginUserRole = localStorage.getItem('UserRole');
    if (loginUserRole === AgencyRoleType.ADMIN) {
      // system user will access all functionality of the app
      return true;
    } else {
      if (
        loginUserRealmRole === AgencyRoleType.ADMIN ||
        loginUserRealmRole === AgencyRoleType.AGENCYADMIN ||
        loginUserRealmRole === AgencyRoleType.AGENCYNURSE ||
        loginUserRealmRole === AgencyRoleType.SEMBRANETADMIN ||
        loginUserRealmRole === AgencyRoleType.SEMBRANETNURSE ||
        loginUserRealmRole === AgencyRoleType.SEMBRANETOFFICE ||
        loginUserRealmRole === AgencyRoleType.SPECIALTYSUPPORT ||
        loginUserRealmRole === AgencyRoleType.SUPPORT ||
        loginUserRealmRole === AgencyRoleType.OWNER
      ) {
        // as per rule the above roles can chat with everyone
        return true;
      } else {
        return false;
      }
    }
  }

  goTo(link: string) {
    this.showLoader = true;
    this.router.navigate([`/${link}`]);
    this.showLoader = false;
  }

  openUserGuide() {
    this.showUserGuide = true;
  }

}
